// extracted by mini-css-extract-plugin
export default {"label":"ProfileModal_label__So9XO","error":"ProfileModal_error__rxay-","customCheckbox":"ProfileModal_customCheckbox__EWvvD"};